export default __webpack_public_path__ + "static/media/tplate2dyna.28500287.png";